module.exports = __webpack_public_path__ + "media/images/views/dashboard/star-default-870e33e54353e9a4fd6a85f5b5d612bd.svg";